import { createRouter, createWebHistory } from 'vue-router';
import UserLogin from '@/views/UserLogin.vue';
import RecuperarSenha from '@/views/Cadastro/RecuperarSenha.vue';
import CadastroInicio from '@/views/Cadastro/CadastroInicio.vue';
import CadastroFinalizacao from '@/views/Cadastro/CadastroFinalizacao.vue';
import DashboardInicio from '@/views/Dashboard.vue';
import ConfirmarConta from '@/views/ConfirmarConta.vue';
import CadastroPF_Passo_1 from '@/views/Cadastro/PF/CadastroPF_Passo_1.vue';
import CadastroPJ_Passo_1 from '@/views/Cadastro/PJ/CadastroPJ_Passo_1.vue';
import CadastroFI_Passo_1 from '@/views/Cadastro/FI/CadastroFI_Passo_1.vue';
import Dashboard_Inicio from '@/views/Dashboard/Inicio.vue';
import RealizarAssinaturaDeclaracao from '@/views/RealizarAssinaturaDeclaracao.vue'

const routes = [
  
  {
    path: '/Dashboard',
    name: 'Dashboard_Inicio',
    component: Dashboard_Inicio
  },
  {
    path: '/CadastroPF_Passo_1',
    name: 'CadastroPF_Passo_1',
    component: CadastroPF_Passo_1
  },
  {
    path: '/CadastroPJ_Passo_1',
    name: 'CadastroPJ_Passo_1',
    component: CadastroPJ_Passo_1
  },
  {
    path: '/CadastroFI_Passo_1',
    name: 'CadastroFI_Passo_1',
    component: CadastroFI_Passo_1
  },
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardInicio
  },
  {
    path: '/ConfirmarConta/:id',
    name: 'ConfirmarConta',
    component: ConfirmarConta
  },
  {
    path: '/RealizarAssinaturaDeclaracao/:id',
    name: 'RealizarAssinaturaDeclaracao',
    component: RealizarAssinaturaDeclaracao
  },
  
  // {
  //   path: '/FinalizarCadastroPF',
  //   name: 'FinalizarCadastroPF',
  //   component: CadastroPF_Passo_1
  // },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin
  },
  {
    path: '/CadastroInicio',
    name: 'CadastroInicio',
    component: CadastroInicio
  },
  {
    path: '/CadastroFinalizacao',
    name: 'CadastroFinalizacao',
    component: CadastroFinalizacao
  },
  {
    path: '/RecuperarSenha',
    name: 'RecuperarSenha',
    component: RecuperarSenha
  },
  // ...outras rotas
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/CadastroInicio', '/CadastroFinalizacao', '/RecuperarSenha'];

  const isPublicRoute = publicPages.includes(to.path);

  // Verifica se a rota atual corresponde ao padrão de uma rota dinâmica pública
  const isPublicDynamicRoute = /^\/ConfirmarConta\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(to.path);

  const isPublicDynamicRouteDoc = /^\/RealizarAssinaturaDeclaracao\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(to.path);

  // Se é uma rota pública (estática ou dinâmica), não precisa de autenticação
  const authRequired = !(isPublicRoute || isPublicDynamicRoute || isPublicDynamicRouteDoc);

  const token = localStorage.getItem('token');

  if (authRequired && token == null) {
    next('/login');
  } else {
    next();
  }
});

export default router;
